// extracted by mini-css-extract-plugin
export default {"wrapper":"lxfl_tcb"};